import { render, staticRenderFns } from "./lni-janitorial-risk-hand-wrist.component.vue?vue&type=template&id=6f3f05be"
import script from "./lni-janitorial-risk-hand-wrist.component.vue?vue&type=script&lang=js"
export * from "./lni-janitorial-risk-hand-wrist.component.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports